import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CountRenderedServicesQuery(
    $filters: [Filter]
    $companyId: ID!
    $usageUnitId: ID!
  ) {
    Me {
      id
      Company(id: $companyId) {
        UsageUnit(id: $usageUnitId) {
          data: countRegistrations(options: { filters: $filters })
        }
      }
    }
  }
`
